module.exports = __webpack_public_path__ + "img/流程2.4ebd792c.png";